module.exports = __webpack_public_path__ + "img/gov-icon-01.9874340c.gif";